import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from '@mui/material';
export const FullSkeleton = () => _jsx(Skeleton, { variant: "rounded", height: "100cqh", width: "100cqw", animation: false });
